
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.5827',
  depVersions: {
  "embedded-viral-link-ui": "static-1.5827",
  "head-dlb": "static-1.4465",
  "hs-test-utils": "static-1.7467",
  "hubspot-dlb": "static-2.1707",
  "HubStyleTokens": "static-2.10990",
  "I18n": "static-7.1484",
  "jasmine-runner": "static-1.5906",
  "quartz": "static-1.6313",
  "quartz-core": "static-1.5532",
  "react-dlb": "static-1.64",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.636",
  "enviro": "static-4.345",
  "foundations-components": "static-1.7044",
  "history": "static-4.47",
  "hub-http": "static-1.5499",
  "hubspot-url-utils": "static-1.3531",
  "HubStyle": "static-2.11298",
  "icons": "static-2.599",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.6650",
  "PortalIdParser": "static-2.319",
  "quartz-config": "static-1.91",
  "quick-fetch": "static-1.3499",
  "react": "static-7.151",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.16",
  "react-rhumb": "static-1.16169",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.4908",
  "react-virtualized": "static-2.87",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "signup-constants": "static-1.17870",
  "signup-ui-lego-core": "static-1.19880",
  "styled-components": "static-2.64",
  "StyleGuideUI": "static-3.478",
  "ui-addon-react-router-dom": "static-1.9091",
  "ui-images": "static-2.998",
  "UIComponents": "static-3.7937",
  "usage-tracker": "static-1.6890",
  "usage-tracker-core": "static-1.6740",
  "viral-links-lib": "static-1.6472",
  "hs-promise-rejection-tracking": "static-1.4918",
  "raven": "static-3.5386",
  "raven-hubspot": "static-1.5693",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9058",
  "bend-plugin-trellis-migration": "static-1.3010",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2590",
  "quartz-webpack": "static-1.2537",
  "HeadJS": "static-2.646",
  "framer-motion": "static-1.58",
  "hs-test-utils-bend-plugin": "static-1.2578",
  "msw": "static-1.39",
  "testing-library": "static-1.140",
  "foundations-theming": "static-1.3880",
  "i18n-data": "static-1.211",
  "moment-timezone": "static-5.73",
  "jasmine": "static-4.3795",
  "dispatcher": "static-1.126",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.723",
  "hub-http-shared-msw-handlers": "static-1.8823",
  "hubspotter-http": "static-1.4170",
  "hubspotter-http-shared-msw-handlers": "static-1.8821",
  "mobile-manifest-mixins": "static-1.419",
  "ui-fonts": "static-1.335",
  "sassPrefix": "static-1.145",
  "bend-plugin-foundations-components": "static-1.3313",
  "floating-ui": "static-1.46",
  "foundations-assets": "static-1.4341",
  "foundations-theming-specialty": "static-1.1596",
  "hs-story-utils": "static-1.8886",
  "react-aria": "static-1.44",
  "tanstack-table": "static-1.23",
  "superstore": "static-1.4248",
  "csstype": "static-1.50",
  "rpc-client-utils": "static-1.4175",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.437",
  "signup-ui-url-generator": "static-2.7568",
  "bender-build-tools": "static-1.2659",
  "bend-plugin-foundations-theming": "static-1.2363",
  "foundations-theming-base": "static-1.2865",
  "stylex": "static-1.22",
  "ts-schema": "static-1.3675"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.5827",
  "head-dlb": "/head-dlb/static-1.4465",
  "hs-test-utils": "/hs-test-utils/static-1.7467",
  "hubspot-dlb": "/hubspot-dlb/static-2.1707",
  "HubStyleTokens": "/HubStyleTokens/static-2.10990",
  "I18n": "/I18n/static-7.1484",
  "jasmine-runner": "/jasmine-runner/static-1.5906",
  "quartz": "/quartz/static-1.6313",
  "quartz-core": "/quartz-core/static-1.5532",
  "react-dlb": "/react-dlb/static-1.64",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.636",
  "enviro": "/enviro/static-4.345",
  "foundations-components": "/foundations-components/static-1.7044",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5499",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
  "HubStyle": "/HubStyle/static-2.11298",
  "icons": "/icons/static-2.599",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.6650",
  "PortalIdParser": "/PortalIdParser/static-2.319",
  "quartz-config": "/quartz-config/static-1.91",
  "quick-fetch": "/quick-fetch/static-1.3499",
  "react": "/react/static-7.151",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.16",
  "react-rhumb": "/react-rhumb/static-1.16169",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.4908",
  "react-virtualized": "/react-virtualized/static-2.87",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "signup-constants": "/signup-constants/static-1.17870",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19880",
  "styled-components": "/styled-components/static-2.64",
  "StyleGuideUI": "/StyleGuideUI/static-3.478",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9091",
  "ui-images": "/ui-images/static-2.998",
  "UIComponents": "/UIComponents/static-3.7937",
  "usage-tracker": "/usage-tracker/static-1.6890",
  "usage-tracker-core": "/usage-tracker-core/static-1.6740",
  "viral-links-lib": "/viral-links-lib/static-1.6472",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
  "raven": "/raven/static-3.5386",
  "raven-hubspot": "/raven-hubspot/static-1.5693",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9058",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3010",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2590",
  "quartz-webpack": "/quartz-webpack/static-1.2537",
  "HeadJS": "/HeadJS/static-2.646",
  "framer-motion": "/framer-motion/static-1.58",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2578",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.140",
  "foundations-theming": "/foundations-theming/static-1.3880",
  "i18n-data": "/i18n-data/static-1.211",
  "moment-timezone": "/moment-timezone/static-5.73",
  "jasmine": "/jasmine/static-4.3795",
  "dispatcher": "/dispatcher/static-1.126",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.723",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8823",
  "hubspotter-http": "/hubspotter-http/static-1.4170",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8821",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.419",
  "ui-fonts": "/ui-fonts/static-1.335",
  "sassPrefix": "/sassPrefix/static-1.145",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3313",
  "floating-ui": "/floating-ui/static-1.46",
  "foundations-assets": "/foundations-assets/static-1.4341",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1596",
  "hs-story-utils": "/hs-story-utils/static-1.8886",
  "react-aria": "/react-aria/static-1.44",
  "tanstack-table": "/tanstack-table/static-1.23",
  "superstore": "/superstore/static-1.4248",
  "csstype": "/csstype/static-1.50",
  "rpc-client-utils": "/rpc-client-utils/static-1.4175",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7568",
  "bender-build-tools": "/bender-build-tools/static-1.2659",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2363",
  "foundations-theming-base": "/foundations-theming-base/static-1.2865",
  "stylex": "/stylex/static-1.22",
  "ts-schema": "/ts-schema/static-1.3675"
}
};
